import Vue from 'vue'
import { createNuxtContext } from './runtime'

function getComponentDefinition(component) {
  return component.default || component
}

function getInitialData(definition, vm) {
  if (!definition || typeof definition.data === 'undefined') return {}
  if (typeof definition.data === 'function') {
    return definition.data.call(vm || {}) || {}
  }
  return definition.data || {}
}

function callHook(hook, vm, args = []) {
  if (!hook) return
  const hooks = Array.isArray(hook) ? hook : [hook]
  hooks.forEach(fn => {
    if (typeof fn === 'function') {
      fn.apply(vm, args)
    }
  })
}

function applyAsyncData(vm, data) {
  Object.keys(data || {}).forEach(key => {
    vm.$set(vm, key, data[key])
  })
}

function updateHead(vm) {
  if (!vm || typeof vm.$options.head !== 'function') return
  const result = vm.$options.head.call(vm) || {}
  if (result.title) {
    document.title = result.title
  }
}

async function runHooks(definition, route, vm) {
  const ctx = createNuxtContext(route, vm)
  let asyncDataResult = {}

  if (typeof definition.asyncData === 'function') {
    asyncDataResult = (await definition.asyncData(ctx)) || {}
  }

  if (typeof definition.fetch === 'function') {
    await definition.fetch(ctx)
  }

  return asyncDataResult
}

export function wrapPage(component) {
  const definition = getComponentDefinition(component)
  const originalMounted = definition.mounted
  const originalBeforeRouteEnter = definition.beforeRouteEnter
  const originalBeforeRouteUpdate = definition.beforeRouteUpdate

  return {
    ...definition,
    name: `NuxtCompat_${definition.name || 'Page'}`,
    data() {
      return getInitialData(definition, this)
    },
    async beforeRouteEnter(to, from, next) {
      try {
        const data = await runHooks(definition, to)
        next(vm => {
          if (typeof originalBeforeRouteEnter === 'function') {
            originalBeforeRouteEnter(to, from, () => {})
          }
          applyAsyncData(vm, data)
          updateHead(vm)
        })
      } catch (error) {
        next(vm => {
          vm.$message && vm.$message.error(error.message || error)
        })
      }
    },
    async beforeRouteUpdate(to, from, next) {
      try {
        const data = await runHooks(definition, to, this)
        if (typeof originalBeforeRouteUpdate === 'function') {
          originalBeforeRouteUpdate.call(this, to, from, () => {})
        }
        applyAsyncData(this, data)
        updateHead(this)
        next()
      } catch (error) {
        this.$message && this.$message.error(error.message || error)
        next(false)
      }
    },
    mounted() {
      callHook(originalMounted, this)
      updateHead(this)
    }
  }
}
